var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.862,
    height: 18.235,
    viewBox: "8.065 17.428 32.862 18.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.493 21.125a5.43 5.43 0 1 1 .039 10.862 5.43 5.43 0 0 1-.039-10.862Zm-16.148 4.68a28.537 28.537 0 0 1 2.76-2.91c3.842-3.497 8.211-5.367 12.736-5.463 4.524-.096 9.115 1.583 13.463 5.166a32.6 32.6 0 0 1 3.353 3.21c.333.374.361.93.067 1.336a21.36 21.36 0 0 1-4.112 4.388 18.592 18.592 0 0 1-11.587 4.131 20.322 20.322 0 0 1-11.835-3.84 23.892 23.892 0 0 1-4.896-4.647 1.054 1.054 0 0 1 .05-1.372Zm4.18-1.338a26.58 26.58 0 0 0-2.03 2.057 21.622 21.622 0 0 0 3.91 3.575 18.253 18.253 0 0 0 10.612 3.457 16.496 16.496 0 0 0 10.271-3.668 18.943 18.943 0 0 0 3.209-3.29c-.8-.838-1.648-1.63-2.54-2.369-3.945-3.251-8.084-4.77-12.087-4.687-4.003.083-7.883 1.762-11.346 4.915Zm10.612-2.083a2.104 2.104 0 1 1 0 4.21 2.104 2.104 0 0 1 0-4.21Z",
    fill: "#82ceee",
    fillRule: "evenodd",
    "data-name": "view-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.901be2b33e26cb5a3332f591acebff65.svg";
export { ForwardRef as ReactComponent };